import FormField from './FormField';

import NumberInput from './NumberInput';

// If you need to extend NumberInput functionality keep in mind that {...props} is on FormControl to support all Chakra props
// Specific props for NumberInput should be excluded from ...props and manually added
const NumberInputField = ({
    placeholder,
    precision,
    step,
    min,
    max,
    value,
    onChange,
    hasStepperButtons,
    rightElement,
    leftElement,
    ...props
}) => (
    <FormField {...props}>
        <NumberInput
            // zDefaultValue could be returned and Chakra uses toString(value)
            value={Number.isNaN(Number.parseFloat(value)) ? '' : value}
            onChange={onChange}
            placeholder={placeholder}
            precision={precision}
            step={step}
            max={max}
            min={min}
            hasStepperButtons={hasStepperButtons}
            rightElement={rightElement}
            leftElement={leftElement}
        />
    </FormField>
);

export default NumberInputField;
